/**
 * Stable per-tab CRM activity session id (joins sessions, heartbeats, audit).
 */
const STORAGE_KEY = 'lctf_crm_activity_session_id_v1';

function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `sess_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

let cached: string | null = null;

export function getCrmActivitySessionId(): string {
  if (cached) return cached;
  if (typeof sessionStorage !== 'undefined') {
    try {
      const existing = sessionStorage.getItem(STORAGE_KEY);
      if (existing) {
        cached = existing;
        return existing;
      }
      const next = randomId();
      sessionStorage.setItem(STORAGE_KEY, next);
      cached = next;
      return next;
    } catch {
      // fall through
    }
  }
  cached = randomId();
  return cached;
}
